import React from 'react';
import { profileData } from '../data/siteContent';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* DJ NEFF Logo Watermark Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="flex flex-col h-full justify-around">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex justify-around whitespace-nowrap">
              {[...Array(5)].map((_, j) => (
                <img
                  key={j}
                  src="https://customer-assets.emergentagent.com/job_professional-epk/artifacts/k20ff6ft_IMG_4353_2-removebg-preview.png"
                  alt=""
                  className="w-32 h-32 md:w-40 md:h-40 object-contain"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-white space-y-6">
            <h1 className="text-7xl md:text-9xl font-black tracking-tighter">
              {profileData.name}
            </h1>
            <p className="text-xl md:text-2xl font-light tracking-wide">
              {profileData.tagline}
            </p>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="aspect-square rounded-lg overflow-hidden border-4 border-white shadow-2xl">
              <img
                src={profileData.hero_image}
                alt={profileData.name}
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <svg
          className="w-6 h-6"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
